export default __webpack_public_path__ + "static/project-slide-4-1248-765-90b24ccf0601ab119affc6db151af44c.webp";